import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, Download } from "lucide-react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); setTimeout(() => setShowPrompt(true), 3000); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt(); await deferredPrompt.userChoice;
    setDeferredPrompt(null); setShowPrompt(false);
  };

  if (!showPrompt || dismissed) return null;

  return (
    <div data-testid="pwa-install-prompt" className="fixed bottom-4 left-4 right-4 z-50 animate-fade-in-up opacity-0 max-w-lg mx-auto">
      <div className="glass rounded-2xl p-4 flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#e91e63] flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Install SmileSense</p>
          <p className="text-xs text-[#5a5873] truncate">Add to home screen for quick access</p>
        </div>
        <Button data-testid="pwa-install-btn" onClick={handleInstall} size="sm"
          className="rounded-xl bg-[#e91e63] text-white hover:bg-[#f44a7a] text-xs font-semibold px-4">Install</Button>
        <button data-testid="pwa-dismiss-btn" onClick={() => { setDismissed(true); setShowPrompt(false); }}
          className="text-[#5a5873] hover:text-white transition-colors"><X className="w-4 h-4"/></button>
      </div>
    </div>
  );
}
